// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"d1-z","sponsoredTooltipWrapper":"e1-z","sponsoredTooltip":"f1-z","newCard":"g1-z"};